import { FC } from 'react';
import ColumnTilesStyled from './ColumnTilesStyled';

import getAsset from '~/helpers/getAsset';




interface ScreenProps {
  tile1Header?: string;
  tile1Content?: string;
  tile2Header?: string;
  tile2Content?: string;
  tile3Header?: string;
  tile3Content?: string;
  icon?: string;
}

const ColumnTiles: FC<ScreenProps> = ({ tile1Header, tile1Content, tile2Header, tile2Content, tile3Header, tile3Content }) => {

  return (
    <ColumnTilesStyled data-testid="modal-column-tiles">

        <div className='columnTiles-tile'>
          <div>
            <p><img className='columnTiles-tile-icon' src={getAsset(`/images/logos/netflix-n-logo.svg`)} alt="NetFlix Pro Wi-Fi Bundle" /></p>
          </div>
          <h4 className='columnTiles-tile-header'>{tile1Header || 'Netflix Premium'}</h4>
          <p className='columnTiles-tile-content'>{tile1Content || 'Watch unlimited movies and TV shows in 4K with spatial audio on up to four devices. Plus, get mobile games and ad-free streaming.'}</p>
        </div>

        <div className='columnTiles-tile'>
          <div>
          <p><img className='columnTiles-tile-icon' src={getAsset(`/images/icons/icon-home-wifi.svg`)} alt="NetFlix Pro Wi-Fi Bundle" /></p>
          </div>
          <h4 className='columnTiles-tile-header'>{tile2Header || 'Whole-Home Wifi'}</h4>
          <p className='columnTiles-tile-content'>{tile2Content || 'Supercharge your Wi-Fi coverage with strong Wi-Fi throughout your whole home, from the front porch to the back yard.'}</p>
        </div>

        <div className='columnTiles-tile'>
          <div>
          <p><img className='columnTiles-tile-icon' src={getAsset(`/images/icons/icon-shield-identity-red.svg`)} alt="NetFlix Pro Wi-Fi Bundle" /></p>
          </div>
          <h4 className='columnTiles-tile-header'>{tile3Header || 'Wi-Fi Security'}</h4>
          <p className='columnTiles-tile-content'>{tile3Content || 'Security for your home internet to safeguard your devices, personal information and network from online threats — all managed in the eero app.'}</p>
        </div>

    </ColumnTilesStyled>



  );
};

ColumnTiles.displayName = 'ColumnTiles';

export default ColumnTiles;
